import React from "react"
import { Link, Redirect } from "react-router-dom"
import { connect } from "react-redux"
import propTypes from "prop-types"
import { signUp } from "../../../../services/authentication"
import configs from "../../../../configs"

import Form, {
  Group,
  Description,
  Input,
  Password
} from "../../../../components/Form"
import Nav from "../../../../components/Nav"
import Logo from "../../../../components/Logo"
import Button from "../../../../components/Button"

class SignUp extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      form: {
        firstName: {
          label: "First Name",
          name: "firstName",
          type: "text",
          value: "",
          required: true,
          class: "",
          message: ""
        },
        lastName: {
          label: "Last Name",
          name: "lastName",
          type: "text",
          value: "",
          required: true,
          class: "",
          message: ""
        },
        email: {
          label: "Email",
          name: "email",
          type: "email",
          value: "",
          required: true,
          class: "",
          message: ""
        },
        password: {
          label: "Create Password",
          name: "password",
          type: "password",
          hide: true,
          value: "",
          required: true,
          class: "",
          message: ""
        },
        confirm_password: {
          label: "Confirm Password",
          name: "confirm_password",
          type: "password",
          hide: true,
          value: "",
          required: true,
          requiredField: "password",
          class: "",
          message: ""
        }
      },
      isSubmitted: false,
      successMessage: "",
      currentStep: 1,
      innerLoading: false
    }
  }

  onChange = (name, field, value) => {
    const { form } = this.state

    this.setState({
      form: {
        ...form,
        [name]: {
          ...form[name],
          message: "",
          [field]: value
        }
      }
    })
  }

  onSubmit = e => {
    e.preventDefault()

    const { form } = this.state
    const { onSignUp } = this.props

    this.setState({ innerLoading: true })

    onSignUp(form)
      .then(message => {
        this.setState({
          currentStep: 2,
          successMessage: message,
          innerLoading: false
        })
      })
      .catch(fields => {
        this.setState({
          isSubmitted: true,
          innerLoading: false,
          form: { ...form, ...fields }
        })
      })
  }

  render() {
    const {
      form,
      isSubmitted,
      currentStep,
      successMessage,
      innerLoading
    } = this.state
    const { isLogged, location } = this.props

    if (isLogged) {
      return <Redirect to={location.state ? location.state.from : "/"} />
    }

    return (() => {
      switch (currentStep) {
        case 1:
          return (
            <div
              className={`container-fluid authentication--step-${currentStep}`}
            >
              <div className="row">
                <div className="col-lg-7 authentication_sidebar">
                  <Logo color="white" href="/" title="Resanec" />
                  <Logo color="black" href="/" title="Resanec" mobile />

                  <div className="authentication_sidebar_container">
                    <h1 className="authentication_sidebar_title">
                      NDIS Pre-Planning
                    </h1>
                    <div className="authentication_sidebar_subtitle">
                      Online is easy. When done together, it’s better.
                    </div>
                    <div className="authentication_sidebar_description">
                      <ul>
                        <li>Easy collaboration with family, friends</li>
                        <li>Efficient editing and revising capability</li>
                        <li>
                          Dynamic commenting facility to provide input and
                          feedback on pre-plan progress and is
                        </li>
                        <li>
                          ideal if you live in a remote location....and more.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-lg-5 authentication_content authentication_content--dark">
                  <Nav
                    navigation={configs.authentication.navigation}
                    className="nav--right nav--dark"
                  />

                  <div className="authentication_content_container">
                    <h2 className="authentication_content_title">
                      Create your account
                    </h2>
                    <div className="authentication_content_description">
                      Already have an account?{" "}
                      <Link to="/sign-in">Sign In to your account</Link>
                    </div>

                    <Form onSubmit={this.onSubmit}>
                      <Group>
                        <Input
                          onChange={this.onChange}
                          isSubmitted={isSubmitted}
                          field={form.firstName}
                        />
                      </Group>

                      <Group>
                        <Input
                          onChange={this.onChange}
                          isSubmitted={isSubmitted}
                          field={form.lastName}
                        />
                      </Group>

                      <Group>
                        <Input
                          onChange={this.onChange}
                          isSubmitted={isSubmitted}
                          field={form.email}
                        />
                      </Group>

                      <Group>
                        <Password
                          onChange={this.onChange}
                          isSubmitted={isSubmitted}
                          field={form.password}
                        />
                      </Group>

                      <Group>
                        <Password
                          onChange={this.onChange}
                          isSubmitted={isSubmitted}
                          field={form.confirm_password}
                        />
                      </Group>

                      <Description>
                        By creating an account you are agreeing to our
                        <br />
                        <Link to="/privacy-policy" target="_blank">
                          Privacy Policy
                        </Link>{" "}
                        and{" "}
                        <Link to="/terms-of-service" target="_blank">
                          Terms of service
                        </Link>
                      </Description>

                      <Group>
                        <Button
                          button={{ type: "submit", disabled: innerLoading }}
                          className="btn--secondary btn--width-full btn--height-md"
                        >
                          Sign Up
                        </Button>
                      </Group>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          )
        case 2:
          return (
            <div
              className={`container-fluid authentication--step-${currentStep}`}
            >
              <div className="row">
                <div className="col-lg-7 authentication_sidebar">
                  <Logo color="white" href="/" title="Resanec" />
                  <Logo color="black" href="/" title="Resanec" mobile />

                  <div className="authentication_sidebar_container">
                    <h1 className="authentication_sidebar_title">
                      NDIS Pre-Planning
                    </h1>
                    <div className="authentication_sidebar_subtitle">
                      Online is easy. When done together, it’s better.
                    </div>
                    <div className="authentication_sidebar_description">
                      <ul>
                        <li>Easy collaboration with family, friends</li>
                        <li>Efficient editing and revising capability</li>
                        <li>
                          Dynamic commenting facility to provide input and
                          feedback on pre-plan progress and is
                        </li>
                        <li>
                          ideal if you live in a remote location....and more.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-lg-5 authentication_content authentication_content--dark">
                  <Nav
                    navigation={configs.authentication.navigation}
                    className="nav--right nav--dark"
                  />

                  <div className="authentication_content_container">
                    <h2 className="authentication_content_title">
                      Create your account
                    </h2>
                    <div className="authentication_content_description">
                      Already have an account?{" "}
                      <Link to="/sign-in">Sign In to your account</Link>
                    </div>

                    <div className="authentication_content_description">
                      {successMessage}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        default:
          return null
      }
    })()
  }
}

SignUp.propTypes = {
  onSignUp: propTypes.func,
  history: propTypes.shape({
    push: propTypes.func
  }).isRequired,
  user: propTypes.shape({
    name: propTypes.string
  }).isRequired,
  location: propTypes.shape({
    state: propTypes.shape({
      from: propTypes.object
    })
  }).isRequired,
  isLogged: propTypes.bool.isRequired
}

SignUp.defaultProps = {
  onSignUp: () => {}
}

const mapStateToProps = ({ AuthenticationReducer }) => ({
  isLogged: AuthenticationReducer.isLogged,
  user: AuthenticationReducer.user
})

const mapDispatchToProps = dispatch => ({
  onSignUp: (user, error) => dispatch(signUp(user, error))
})

export default connect(mapStateToProps, mapDispatchToProps)(SignUp)
